// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  userId: __t.u64().name("user_id"),
  email: __t.string(),
  tokenHash: __t.string().name("token_hash"),
  createdAt: __t.u64().name("created_at"),
  expiresAt: __t.u64().name("expires_at"),
  verified: __t.bool(),
});
